{
  "it": {
    "locale_field": {
      "fallback_tooltip": "Se per questa lingua non viene inserito alcun testo, questo testo predefinito verrà utilizzato come alternativa.",
      "translated_in": "Tradotto in"
    }
  }
}
